import { Button, ButtonProps } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { IFile } from '@subflow-frontend/@types/file';
import React from 'react';

export interface ContentLibraryDirectoryNavigationProps {
  parentFolders: Pick<IFile, 'id' | 'name'>[];
  onFolderClick: (file?: Pick<IFile, 'id' | 'name'>) => void;
  hideMyLibrary?: boolean;
  buttonSx?: ButtonProps['sx'];
}

export const ContentLibraryDirectoryNavigation: React.FC<
  ContentLibraryDirectoryNavigationProps
> = ({ parentFolders, onFolderClick, hideMyLibrary, buttonSx }) => {
  return (
    <>
      <Breadcrumbs maxItems={3} aria-label="breadcrumb">
        {!hideMyLibrary && (
          <Button onClick={() => onFolderClick(undefined)} color="inherit">
            My Library
          </Button>
        )}
        {parentFolders.map((folder) => {
          return (
            <Button
              sx={buttonSx}
              key={folder.id}
              color="inherit"
              onClick={() => onFolderClick(folder)}
            >
              {folder.name}
            </Button>
          );
        })}
      </Breadcrumbs>
    </>
  );
};
